<template>
  <v-layout row wrap>
    <v-flex xs12 sm9 md7 class="text-md-left">
      <strong>Foto</strong>
      <v-divider/>
    </v-flex>
    <v-flex xs6 sm1 md2 class="hidden-md-and-down">
      <v-btn color="secundary" @click="$refs.inputUpload.click()" dark>
        Cargar Imagen
      </v-btn>
      <input type="file" v-show="false" ref="inputUpload" accept="image/*"
             capture="camera" id="camera"
             color="primary" name="Capturar">
      <img id="frame" width="350" height="189" style="visibility: hidden">
    </v-flex>
    <v-flex xs6 sm1 md1>
      <v-btn id="initCamera" color="secundary" v-on:click="startCamera()"
             dark small>Init
      </v-btn>
    </v-flex>
    <v-flex xs6 sm2 md1>
      <v-btn id="capture" color="primary" v-on:click="captureFace()"
             dark>Capturar
      </v-btn>
    </v-flex>
    <v-flex xs12 sm6 md6>
      <video id="player" ref="player" controls autoplay width="700" height="378"
             style="padding-right: 20px;">
      </video>
    </v-flex>
    <v-flex xs12 sm6 md6>
      <img id="snapshotImg" ref="snapshotImg" :src="this.baseImg"
           width="700" height="378">
      <canvas id="snapshot" ref="snapshot" style="display: none"></canvas>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  name: 'camera',
  data() {
    return {
      baseImg: 'data:image/png;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw==',
      fotos: this.value,
      constraints: { video: { width: 1280, height: 720 } },
    };
  },
  props: {
    value: {
      type: Array,
      required: true,
    },
  },
  watch: {
    value: {
      inmediate: true,
      handler() {
        if (this.value.length === 0) {
          document.getElementById('frame').removeAttribute('src');
          document.getElementById('snapshotImg').src = this.baseImg;
        }
      },
    },
  },
  methods: {
    captureMovileFace(file) {
      const frame = document.getElementById('frame');
      this.fotos = [];
      // Do something with the image file.
      frame.src = URL.createObjectURL(file);
      const imageObj = new Image();
      imageObj.src = frame.src;
      const imageToShow = document.getElementById('snapshotImg');
      imageToShow.src = URL.createObjectURL(file);
      this.fotos.push(file);
      this.$emit('input', this.fotos);
      console.log(file);
    },
    captureFace() {
      console.log('captureFace');
      const snapshotCanvas = document.getElementById('snapshot');
      const imageToShow = document.getElementById('snapshotImg');
      this.fotos = [];
      snapshotCanvas.width = this.player.videoWidth;
      snapshotCanvas.height = this.player.videoHeight;
      const context = snapshotCanvas.getContext('2d');
      context.drawImage(this.player, 0, 0);
      snapshotCanvas.toBlob((blob) => {
        this.fotos.push(blob);
        this.$emit('input', this.fotos);
      }, 'image/png');
      imageToShow.src = snapshotCanvas.toDataURL('image/png');
    },
    initCamera() {
      if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
        console.log('initCamera');
        navigator.mediaDevices.getUserMedia(this.constraints);
        /*
          p.then((stream) => {
            const video = document.querySelector('video');
            video.srcObject = stream;
          });
          p.catch((err) => {
            console.log(err.name + ': ' + err.message);
          });
          */
      }
    },
    startCamera() {
      if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
        console.log('startCamera');
        this.player = document.querySelector('video');
        // const hdConstraints = { video: { width: { min: 1280 }, height: { min: 720 } } };
        navigator.mediaDevices.getUserMedia(this.constraints)
          .then((stream) => {
            this.player.srcObject = stream;
          });
      }
    },
    stopCamera() {
      this.player.srcObject.getTracks().forEach((track) => {
        track.stop();
      });
    },
  },
  beforeDestroy() {
    console.log('cerrando componente camara');
    this.fotos = [];
    this.stopCamera();
  },
  mounted() {
    this.initCamera();
    const camera = document.getElementById('camera');
    const pointer = this;
    camera.addEventListener('change', (e) => {
      pointer.captureMovileFace(e.target.files[0]);
    });
    this.startCamera();
  },
};
</script>

<style scoped>

</style>
